<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EcCT6J/tc-custom/9781488059834.jpg?1726273360594" alt="This image is the cover for the book Her Cowboy Reunion and Hill Country Reunion, Western Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Her Cowboy Reunion and Hill Country Reunion, Western Collection
      </h1>
      <p class="bookDescription body article font2">
        <p>Her Cowboy Reunion by Ruth Logan Herne<br/><br/>With her family in disgrace, Lizzie Fitzgerald never imagined she’d end up at an Idaho ranch. She loves working with the horses—even if it means dealing with her old sweetheart Heath Caufield. The widowed father of an adorable boy, Heath hasn’t forgiven Lizzie for their past. But even a stubborn cowboy can’t stop the heart’s ability to forgive…or love again.<br/><br/>Hill Country Reunion by Myra Johnson<br/><br/>Veterinarian Tripp Willoughby thought keeping his chronic illness a secret was the right thing to do—but he ended up breaking his college girlfriend’s heart. Diana Matthews has a new life now, and she’s reluctant to accept Tripp’s help with her pet therapy program. As they work together, Tripp remembers how things used to be with Diana—and is convinced he must find a way to win her back.<br/><br/><i>USA TODAY</i> Bestselling Author Ruth Logan Herne</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ruth Logan Herne, Myra Johnson
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f8a3301